/* DROP-01 — page produit. Galerie, quantité, sélection de variante.
   Aucune donnée en dur : les variantes viennent du JSON injecté par la section. */
(function () {
  'use strict';

  function init(root) {
    var form = root.querySelector('[data-dp-form]');
    var dataEl = root.querySelector('[data-dp-variants]');
    if (!form || !dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    /* --- entrée en glissement --- */
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.add('dp-anim');
      requestAnimationFrame(function () { root.classList.add('is-ready'); });
    }

    /* --- galerie --- */
    var main = root.querySelector('[data-dp-main]');
    var thumbs = root.querySelectorAll('[data-dp-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
        t.classList.add('is-on');
        t.setAttribute('aria-pressed', 'true');
        if (!main) return;
        main.classList.add('is-fading');
        setTimeout(function () {
          main.src = t.getAttribute('data-src');
          main.classList.toggle('is-photo', t.getAttribute('data-photo') === '1');
          main.classList.remove('is-fading');
        }, 200);
      });
    });

    /* --- quantité --- */
    var qty = root.querySelector('[data-dp-qty]');
    root.querySelectorAll('[data-dp-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-dp-qty-step'), 10);
        qty.value = Math.max(1, n);
      });
    });

    /* --- variante --- */
    var idInput = form.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-dp-price]');
    var addBtn = root.querySelector('[data-dp-add]');
    var buyBtn = root.querySelector('[data-dp-buy]');
    var locale = document.documentElement.lang || 'fr-CA';
    var currency = root.getAttribute('data-currency');

    function money(cents) {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    function selectedOptions() {
      var out = [];
      root.querySelectorAll('[data-dp-option]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        out.push(checked ? checked.value : null);
      });
      return out;
    }

    function update() {
      var sel = selectedOptions();
      var match = null;
      variants.forEach(function (v) {
        var ok = true;
        for (var i = 0; i < sel.length; i++) { if (v.options[i] !== sel[i]) { ok = false; break; } }
        if (ok) match = v;
      });
      var available = !!(match && match.available);
      if (match) {
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
      [addBtn, buyBtn].forEach(function (b) { if (b) b.disabled = !available; });
      if (addBtn) addBtn.textContent = available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-soldout');
    }

    root.querySelectorAll('[data-dp-option] input').forEach(function (i) {
      i.addEventListener('change', update);
    });
    update();
  }

  document.querySelectorAll('[data-drop-product]').forEach(init);
})();
